<!--
 * $Description: 
 * $Author: Betway
 * @最后编辑: Betway
 * $Date: 2020年03月13日 10:18:19 +0800
 * @最后修改时间: 2021-11-11 11:54:24
 * @FilePath: \mrc-ess-fronted\src\Page\EssAdmin\Approval\ApprovalProcess\viewRosterApprovalProcess.vue
 -->
<template>
  <noContent v-if="RosterRecordTitle === null" />

  <ContentLayout
    v-else
    widthClass=" min-1200"
    backgroundClass="transparent"
    pad="0"
    :title="RosterRecordTitle"
  >
    <template v-slot:nav-actions>
      <approvalTools
        v-if="RosterRecordData && RosterRecordData['flow_status'] == 1"
        :curUuid="RosterRecordData['uuid']"
        :staff_uuid="curStaff"
        :flag="RosterRecordData['cancel_flag']"
        :data_type="RosterRecordData['data_type']"
        :final_node="Number(RosterRecordData['is_final_task_node'])"
        :matched="Number(RosterRecordData['is_match']) ? true : false"
        :canRevoke="Number(RosterRecordData['is_allow_revoke'])"
        :canRollback="Number(RosterRecordData['is_allow_rollback'])"
        :canForward="Number(RosterRecordData['is_allow_forward'])"
        @back="onBack"
        @forward="onForward"
        @approval="onApproval"
        @reject="onReject"
      />
    </template>
    <!-- content -->
    <template v-slot:page-main>
      <ApprovalTriger
        v-if="RosterRecordData"
        :bg-color="RosterRecordData.approval_bg_color"
        :slide-color="RosterRecordData.approval_tint_color"
        @triger="
          $toPage(
            '/admin/approval-process/roster-detail/' +
              $route.params.params +
              '/approval-detail/' +
              $route.params.params
          )
        "
      >
        <template v-slot:time>
          {{
            $getDateTime(
              RosterRecordData.operate_utc_datetime,
              "YYYY/MM/DD HH:mm"
            )
          }}
        </template>
        <template v-slot:status>
          {{ $getCommonLangValue(RosterRecordData.status_detail) }}
        </template>
      </ApprovalTriger>
      <Taber
        :curTab="curTab"
        @change="(tab) => (curTab = tab)"
        :items="taber"
        special
        contentBackground="mrc-grey pa-0"
      >
        <template v-slot:content-1>
          <v-container class="rounded-lg pa-0" fluid>
            <v-card
              class="rounded-lg"
              :class="iSEdited ? 'pa-1' : 'pa-1'"
              :elevation="0"
            >
              <v-card-text class="rounded-lg transparent pa-0">
                <v-form
                  ref="form"
                  lazy-validation
                  :class="iSEdited ? 'rounded-lg' : 'rounded-lg'"
                  class="transparent pa-3 fill-height scroll_content"
                >
                  <v-row>
                    <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                      <normalInputTextFiled
                        :readonly="true"
                        :filled="false"
                        v-model="RosterRecordData.roster_form_record_title"
                        :label="
                          $t(
                            'label_essweb_RosterFormRecord_form_rosterNameLabel'
                          )
                        "
                        :rules="$GetRules(['_Require_Rules'], [null])"
                        dense
                      />
                    </v-col>
                    <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                      <v-sheet class="text--secondary">{{
                        $t("label_essweb_RosterFormRecord_form_startDateLabel")
                      }}</v-sheet>
                      <v-text-field
                        :readonly="true"
                        :filled="false"
                        dense
                        single-line
                        v-model="RosterRecordData.roster_utc_start_date"
                        :label="
                          $t(
                            'label_essweb_RosterFormRecord_form_startDateLabel'
                          )
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                      <v-sheet class="text--secondary">{{
                        $t("label_essweb_RosterFormRecord_form_endDateLabel")
                      }}</v-sheet>
                      <v-text-field
                        :readonly="true"
                        :filled="false"
                        dense
                        single-line
                        v-model="RosterRecordData.roster_utc_end_date"
                        :label="
                          $t('label_essweb_RosterFormRecord_form_endDateLabel')
                        "
                      ></v-text-field>
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                      <normalInputTextFiled
                        :readonly="true"
                        :filled="false"
                        v-model="
                          RosterRecordData.roster_form_record_description
                        "
                        :label="
                          $t(
                            'label_essweb_RosterFormRecord_form_descriptionLabel'
                          )
                        "
                      />
                    </v-col>
                    <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                      <normalInputTextFiled
                        :readonly="true"
                        :filled="false"
                        v-model="RosterRecordData.remarks"
                        :label="
                          $t('label_essweb_RosterFormRecord_form_remarkLabel')
                        "
                      />
                    </v-col>
                  </v-row>
                </v-form>
              </v-card-text>
              <!-- <CardActions
                    saveBtn
                    @save="toSave"
                    v-if="iSEdited"
                    @cancel="toBack"
                  /> -->
            </v-card>
            <v-card class="rounded-lg mt-4 pa-0" :elevation="0">
              <v-card-text class="rounded-lg transparent pa-1">
                <v-form
                  ref="form2"
                  lazy-validation
                  :class="iSEdited ? 'rounded-lg' : 'rounded-lg'"
                  class="white pa-3 fill-height scroll_content"
                >
                  <v-row>
                    <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                      <normalInputTextFiled
                        :readonly="true"
                        :filled="false"
                        v-model="
                          RosterRecordData.roster_form_record_swift_number
                        "
                        :label="
                          $t(
                            'label_essweb_RosterFormRecord_form_swiftNumberLabel'
                          )
                        "
                      />
                    </v-col>
                    <v-col xs="12" sm="6" md="6" lg="6" cols="12">
                      <normalInputTextFiled
                        :readonly="true"
                        :filled="false"
                        v-model="RosterRecordData.remarks"
                        :label="
                          $t('label_essweb_RosterFormRecord_form_remarkLabel')
                        "
                      />
                    </v-col> </v-row
                ></v-form>
              </v-card-text>
            </v-card>
            <v-card class="rounded-lg mt-4" rounded-lg elevation="0">
              <v-card-text class="rounded-lg">
                <div class="title pa-2 black--text">
                  {{
                    $t(
                      "label_essweb_RosterFormRecord_form_table_avaliblehiftTitle"
                    )
                  }}
                </div>
                <v-row>
                  <v-col
                    xs="12"
                    sm="6"
                    md="6"
                    lg="6"
                    cols="12"
                    v-for="(item, index) in ShiftList"
                    :key="`shift--${index}`"
                  >
                    <v-list-item two-line dense>
                      <v-list-item-avatar
                        :color="item.color_code"
                        rounded
                        size="48"
                        :width="3 * 48"
                        class="mr-2 round-lg"
                      >
                        <div class="text-truncate black--text pa-1">
                          {{ item.shift_abbr }}
                        </div>
                      </v-list-item-avatar>
                      <v-list-item-content>
                        <v-list-item-title class="d-flex align-center">
                          <svg-icon
                            size="20"
                            :fill="item.color_code"
                            iconClass="LabeledColour"
                          />
                          <span class="black--text pl-1">{{
                            item.shift_abbr
                          }}</span>
                        </v-list-item-title>
                        <v-list-item-subtitle class="pl-6 text--secondary">
                          {{
                            $timeMachine(item.start_utc_time) +
                            " - " +
                            $timeMachine(item.end_utc_time)
                          }}
                        </v-list-item-subtitle>
                      </v-list-item-content>
                    </v-list-item>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-container>
        </template>
        <template v-slot:content-2>
          <v-card class="fill-height max-width pa-0 elevation-0">
            <v-card-text class="fill-height max-width pa-2 pt-3">
              <RosterPlan
                :Roster_uuid="Roster_uuid"
                :change="isChange"
                :iSEdited="iSEdited"
                :shiftList="ShiftList"
                :startTime="RosterRecordData.roster_utc_start_date"
                :endTime="RosterRecordData.roster_utc_end_date"
              />
            </v-card-text>
          </v-card>
        </template>
        <template v-slot:content-3>
          <v-card class="fill-height max-width pa-0 elevation-0">
            <v-card-text class="fill-height max-width pa-2 pt-3">
              <RosterPlanB
                :Roster_uuid="Roster_uuid"
                :change="isChange"
                :iSEdited="iSEdited"
                :shiftList="ShiftList"
                :startTime="RosterRecordData.roster_utc_start_date"
                :endTime="RosterRecordData.roster_utc_end_date"
              />
            </v-card-text>
          </v-card>
        </template>
        <!-- <template v-slot:content-4>
          <v-card class="fill-height max-width pa-0 elevation-0 rounded-lg">
            <v-card-text class="fill-height max-width pa-2 pt-3">
              <v-form
                ref="form3"
                lazy-validation
                :class="iSEdited ? 'rounded-lg' : 'rounded-lg'"
                class="white pa-3 fill-height scroll_content"
              >
                <v-row>
                  <v-col xs="12" sm="12" md="12" lg="12" cols="12">
                    <v-sheet class="text--secondary">{{
                      $t("label_essweb_RosterFormRecord_form_messageLabel")
                    }}</v-sheet>
                    <v-textarea
                      rows="5"
                      no-resize
                      maxlength="500"
                      counter="500"
                      dense
                      :readonly="true"
                      :filled="true"
                      single-line
                      v-model="RosterRecordData.remarks"
                      name="input-7-4"
                    
                    ></v-textarea> </v-col></v-row
              ></v-form>
            </v-card-text>
          </v-card>
        </template> -->
      </Taber>
    </template>
    <!-- tools -->
    <template v-slot:tools-main>
      <normalDialog
        deleteModel
        :dialog="showDelete"
        :title="deleteTitle"
        @close="showDelete = false"
        @confirm="toDelete"
      />
    </template>
  </ContentLayout>
</template>

<script>
import { mapGetters } from "vuex";
import dayjs from "dayjs";
import RosterPlan from "@/Page/Ess/Roster/RosterFormRecord/components/RosterPlan";
import RosterPlanB from "@/Page/Ess/Roster/RosterFormRecord/components/RosterPlan2";
import approvalTools from "@/Page/EssAdmin/Approval/ApprovalProcess/components/approvalTools";

export default {
  name: "viewRosterApprovalProcess",
  components: {
    RosterPlanB,
    RosterPlan,
    approvalTools,
  },
  computed: {
    // companyLang 公司可选语言list
    ...mapGetters(["AppInfo", "companyLang", "defaultLang"]),
    curAppInfo() {
      return this.AppInfo ? JSON.parse(this.AppInfo) : null;
    },
    Roster_uuid() {
      return this.page_params.id;
    },
  },
  data() {
    return {
      RosterRecordTitle: null,
      iSEdited: false,
      lefttab: 0,
      curTab: "tab-1",
      taber: [
        "label_essweb_RosterFormRecord_form_step_rosterInfoLabel",
        "label_essweb_RosterFormRecord_form_step_rosterPlanLabel",
        "label_essweb_RosterFormRecord_form_step_punchRecordLabel",
        // "label_essweb_RosterFormRecord_form_step_messageLabel",//julia
      ],
      deleteTitle: "",
      showEditShift: false,
      mapToDiag: false,
      tabindex: 0,
      curStep: 0,
      curStaff: null,
      isChange: 0,
      curActiveType: null,
      curPorpertyID: null,
      curAction: "new",
      curPorperty: null,
      page: 1,
      staffLoading: false,
      ShiftList: [],
      GenerationList: [],
      SubmitList: [],
      headers: [],
      showDelete: false,
      RosterRecordData: {
        roster_form_record_swift_number: "",
        roster_form_record_title: "",
        roster_form_record_description: "",
        roster_utc_start_date: "",
        roster_start_time_zone: "480",
        roster_utc_end_date: "",
        roster_end_time_zone: "480",
        generation_utc_datetime: "",
        generation_time_zone: "480",
        is_published: "0",
        publish_utc_deadline: "",
        publish_deadline_zone: "",
        publish_utc_datetime: "",
        publish_time_zone: "",
        is_pre_submitted: "0",
        pre_submission_utc_deadline: "",
        pre_submission_deadline_zone: "",
        pre_submission_utc_datetime: "",
        pre_submission_time_zone: "",
        is_submitted: "0",
        submission_utc_deadline: "",
        submission_deadline_zone: "",
        submission_utc_datetime: "",
        submission_time_zone: "",
        is_locked: "0",
        lock_utc_datetime: "",
        lock_time_zone: "",
        form_type_uuid: "",
        manager_uuid: "5",
        publish_flow_task_uuid: "",
        submission_flow_task_uuid: "",
        roster_form_uuid: "",
        roster_property_group_uuid: "",
        remarks: "",
      },
      showPropertyDialog: false,
      desserts: [],
      shiftHeaders: [
        {
          text: "label_essweb_RosterFormRecord_form_table_shiftNameLabel",
          value: "shift_name",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_RosterFormRecord_form_table_shiftTimeLabel",
          value: "shift_time",
          align: "start",
          sortable: false,
        },
        {
          text: "label_essweb_list_components_tools_actionLabel",
          value: "action",
          align: "end",
          sortable: false,
        },
      ],
      page_params: null,
    };
  },
  watch: {},
  mounted() {
    this.page_params = JSON.parse(this.$aesDecrypt(this.$route.params.params)); //解密参数
    this.curStaff = this.curAppInfo["user"]["user_id"];
    const that = this;
    // this.RosterRecordData.roster_form_record_title = this.$getCommonLangKey(
    //   this.companyLang
    // );
    // this.RosterRecordData.roster_form_record_description = this.$getCommonLangKey(
    //   this.companyLang
    // );
    this.getInfo();
    this.getShiftList();
  },
  methods: {
    onReject: function (comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 3,
          business_action: "terminate",
          cancel_flag: this.RosterRecordData.cancel_flag,
          approval_sequence:
            this.RosterRecordData.status_uuid === "Submiting" ? 2 : 1,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_reject_rejectSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onApproval: function (comments = "", sender) {
      const that = this;
      let data = {
        uuid: this.page_params.id,
        data_type: 3,
        business_action: "send",
        cancel_flag: this.RosterRecordData.cancel_flag,
        approval_sequence:
          this.RosterRecordData.status_uuid === "Submiting" ? 2 : 1,
        operate_comment: comments,
      };
      if (sender.length != 0) data["sender_uuid"] = sender.join(",");
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: data,
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_send_approvalSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onForward: function (sender, node, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 3,
          business_action: "forward",
          cancel_flag: this.RosterRecordData.cancel_flag,
          sender_uuid: sender,
          approval_sequence:
            this.RosterRecordData.status_uuid === "Submiting" ? 2 : 1,
          business_action_status: node == 0 ? 4 : 3,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_forward_forwardSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    onBack: function (sender, comments = "") {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_workflow_flow_tasks",
        url: "/approval/push/",
        data: {
          uuid: this.page_params.id,
          data_type: 3,
          cancel_flag: this.RosterRecordData.cancel_flag,
          business_action: "back",
          business_action_status: sender == 0 ? 1 : 2,
          approval_sequence:
            this.RosterRecordData.status_uuid === "Submiting" ? 2 : 1,
          operate_comment: comments,
        },
      }).then((res) => {
        that.$showMessage({
          type: "success",
          text: that.$t(
            "message_essweb_approvalApplication_form_back_backSuccessLabel"
          ),
        });
        that.$toBack();
      });
    },
    getInfo: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "unknown",
        url: "/approval-task/get-approval-task-details/",
        data: {
          data_type: 3,
          uuid: this.page_params.id,
          is_approval: 1,
        },
      }).then((res) => {
        that.RosterRecordTitle = res.data.roster_form_record_title;
        if (res.data.is_published == 0) {
          that.curStep = 1;
        }
        if (res.data.is_published == 1) {
          that.curStep = 2;
        }
        if (res.data.is_submitted == 1) {
          that.curStep = 3;
        }
        res.data.roster_utc_start_date = that.$getDateTime(
          res.data.roster_utc_start_date,
          "YYYY-MM-DD"
        );
        res.data.roster_utc_end_date = that.$getDateTime(
          res.data.roster_utc_end_date,
          "YYYY-MM-DD"
        );
        that.RosterRecordData = res.data;
      });
    },
    getShiftList: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_record",
        url: "/roster-record/get-shifts/",
        data: {
          roster_form_record_uuid: this.page_params.id,
        },
      }).then((res) => {
        that.ShiftList = res.data;
      });
    },
    onSaveShift: function (arr) {
      const that = this;
      var curUuids = [];
      var newUuids = [];
      this.ShiftList.forEach((item) => {
        curUuids.push(item.uuid);
      });
      arr.forEach((item) => {
        newUuids.push({
          shift_uuid: item.shift_uuid, //
          roster_form_record_uuid: that.page_params.id,
        });
      });
      // if (curUuids.length) {
      //   this.$Request({
      //     method: "POST",
      //     table: "ess_att_roster_form_records_detail_shift",
      //     url: "/roster-record-shift/delete/",
      //     data: {

      //       uuids: curUuids.join(","),
      //     },
      // type:'client'
      //   }).then((res) => {
      //     that.ShiftList = [];
      //   });
      // }
      if (newUuids.length) {
        this.$Request({
          method: "POST",
          table: "ess_att_roster_form_records_detail_shift",
          url: "/roster-record-shift/add/",
          data: {
            uuid: that.page_params.id,

            ess_att_roster_form_records_detail_shift: newUuids,
          },
        }).then((res) => {
          that.getShiftList();
          that.isChange = Math.random() * 10000; //触发RosterPlan 更新
        });
      }
    },
    onDelete: function (type, item) {
      const that = this;
      that.curActiveType = type;
      switch (type) {
        case "shift":
          that.deleteTitle = that.$t(
            "label_essweb_RosterFormRecord_form_table_shiftTitle"
          );
          that.curPorpertyID = item.uuid;
          break;
        default:
          break;
      }
      this.$confirmDo(this.deleteTitle).then((res) => {
        if (res) that.toDelete();
      });
    },
    onNew: function (type) {
      const that = this;
      that.curActiveType = type;
      switch (type) {
        case "shift":
          that.showEditShift = true;
          break;
        default:
          break;
      }
    },

    toBack: function () {
      if (this.iSEdited) {
        this.iSEdited = false;
      } else {
        this.$router.back();
      }
    },
    toEdit: function (uuid) {
      this.iSEdited = true;
    },
    toDeleteRecord: function () {
      const that = this;
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/delete/",
        data: {
          uuids: this.page_params.id,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterFormRecord_form_deleteRosterRecprdSuccessLabel"
          ),
          type: "success",
        });
        that.toBack();
      });
    },
    toSave: function () {
      const that = this;
      if (!this.$refs["form"].validate()) {
        this.$showMessage({
          title: this.$t("message_essweb_form_textField_noticeTitle"),
          okText: this.$t("message_essweb_form_textField_fillInAgain"),
          text: this.$t("message_essweb_form_textField_notIncorrect_content"),
          type: "warning",
        });
        return false;
      }
      this.$Request({
        method: "POST",
        table: "ess_att_roster_form_records",
        url: "/roster-record/update/",
        data: {
          uuid: this.page_params.id,
          roster_form_record_title:
            this.RosterRecordData.roster_form_record_title,
          roster_form_record_description:
            this.RosterRecordData.roster_form_record_description,
          remarks: this.RosterRecordData.remarks,
        },
      }).then((res) => {
        that.$showMessage({
          text: that.$t(
            "message_essweb_RosterFormRecord_list_updateRosterFormRecordSuccessLabel"
          ),
          type: "success",
        });
      });
    },
    toDelete: function () {
      const that = this;
      this.showDelete = false;
      var url = "",
        table = "";
      var data = {
        uuids: that.curPorpertyID,
      };
      switch (that.curActiveType) {
        case "shift":
          url = "/roster-record-shift/delete/";
          table = "ess_att_roster_form_records_detail_shift";
          break;
        default:
          break;
      }
      this.$Request({
        method: "POST",
        table: table,
        url: url,
        data: data,
      }).then((res) => {
        if (that.curActiveType == "shift") {
          that.$showMessage({
            text: that.$t(
              "message_essweb_RosterFormRecord_list_deleteShiftSuccessLabel"
            ),
            type: "success",
          });
          that.ShiftList = that.ShiftList.filter(
            (ele) => ele.uuid !== that.curPorpertyID
          );
        }
        that.isChange = Math.random() * 10000; //触发RosterPlan 更新
      });
    },
  },
};
</script>
